// JavaScript Document

// Scripts written by Jacob Bearce @ Weblinx, Inc.

import CALL_PLAYER from "./call-player";
import Swiper from "swiper";

const SLIDESHOW_ARGS = {
    init: true,
    lazy: true,
    speed: 1500,
    effect: "fade",
    autoplay: {
        delay: 6000,
    },
    loop: true,
};

new Swiper (".swiper-container--home", SLIDESHOW_ARGS);

// init "thumbnails" for gallery swiper
const THUMBNAILS = document.querySelectorAll(".menu-list--thumbnails .menu-list__link");

const ARGS = {
    init: THUMBNAILS.length > 0 ? false : true,
    lazy: true,
    speed: 150,
};

// init "gallery" swiper
const GALLERY = new Swiper (".swiper-container--gallery", ARGS);

/**
 * Enable thumbnail pagination
 */
if (THUMBNAILS.length > 0) {
    /**
     * When gallery inits, set first slide to active
     */
    GALLERY.on("init", () => {
        THUMBNAILS[GALLERY.realIndex].classList.add("is-active");
    });

    /**
     * Initialize the gallery
     */
    GALLERY.init();

    /**
     * When gallery transitions to new slide, set active thumbnail
     */
    GALLERY.on("slideChange", () => {
        THUMBNAILS.forEach((thumbnail) => {
            thumbnail.classList.remove("is-active");
        });

        CALL_PLAYER("stopVideo", [], document.querySelector(".swiper-container--gallery"));
        THUMBNAILS[GALLERY.realIndex].classList.add("is-active");
    });

    /**
     * When clicking a thumbnail, set active slide
     */
    for (let i = 0; i < THUMBNAILS.length; i++) {
        THUMBNAILS[i].addEventListener("click", (e) => {
            e.preventDefault();

            const NEXT = ARGS.loop ? i + 1 : i;

            GALLERY.slideTo(NEXT);

            if (THUMBNAILS[i].classList.contains("is-photoswipe")) {
                GALLERY.slides[NEXT].querySelector(".photoswipe").click();
            }
        }, { passive: false });
    }
}

const TESTIMONIAL_ARGS = {
    init: true,
    lazy: true,
    speed: 2000,
    effect: "slide",
    autoplay: {
        delay: 6000,
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
    },
    loop: true,
};

new Swiper (".swiper-container--testimonials", TESTIMONIAL_ARGS);
